<template lang="pug">

    v-card(outlined)

        v-list(subheader two-line)
            v-list-item(style="min-height: 28px;")
                //- v-list-item-avatar
                v-list-item-content.pt-5.pb-0
                    v-list-item-title(style="font-weight: 500;")
                        | {{ title }}
                template(v-if="!readonly && validScorecardCriterion")
                    v-list-item-action.pt-5.pb-0.my-0
                        FormDialog(
                            :handle-create-scorecard-criterion="handleCreateScorecardCriterion"
                            :handle-update-scorecard-criterion="handleUpdateScorecardCriterion"
                            :scorecard-criterion="scorecardCriterion"
                            :scorecard-template="scorecardTemplate"
                            :show-snackbar="showSnackbar"
                        )
                    v-list-item-action.pt-5.pb-0.my-0
                        DestroyDialog(
                            :handle-destroy-scorecard-criterion="handleDestroyScorecardCriterion"
                            :scorecard-criterion="scorecardCriterion"
                            :show-snackbar="showSnackbar"
                        )

        v-list.pb-0(subheader two-line)
            v-list-item
                //- v-list-item-avatar

                v-list-item-content.py-2
                    v-list-item-title(style="font-weight: 500;")
                        | {{ communicationType | titleize }}

                    v-list-item-subtitle Communication Type

                v-list-item-action(v-if="validScorecard && scorecard.conference_vid && !hideConferenceLink")
                    v-btn(
                        color="primary"
                        icon
                        ripple
                        :to="{ name: 'conference_show', params: { conference_key: scorecard.conference_vid } }"
                        target="_blank"
                    )
                        v-icon(color="primary") mdi-open-in-new
                
                v-list-item-action.py-2.my-0(v-if="validScorecardCriterion")
                    v-list-item-title
                        StatusText(:text="status")

                    v-list-item-subtitle Status

        div(style='padding: 0px 20px;')
            v-divider.ma-0

        slot(name='criterion-list-item')

        v-list.pb-0(subheader two-line)
            v-list-item
                //- v-list-item-avatar

                v-list-item-content.py-2
                    v-list-item-title(style="font-weight: 500;")
                        template(v-if="organizationNames && organizationNames.length > 0")
                            | {{ organizationNames.join(", ") }}
                        template(v-else) All


                    v-list-item-subtitle Organization(s)

        div(style='padding: 0px 20px;')
            v-divider.ma-0

        v-list.pb-0(subheader two-line)
            v-list-item
                //- v-list-item-avatar

                v-list-item-content.py-2
                    v-list-item-title(style="font-weight: 500;")
                        template(v-if="campaignNames && campaignNames.length > 0")
                            | {{ campaignNames.join(", ") }}
                        template(v-else) All


                    v-list-item-subtitle Campaign(s)

        div(style='padding: 0px 20px;')
            v-divider.ma-0

        template(v-if="validScorecardCriterion")
            v-list.pb-0(subheader two-line)
                v-list-item
                    //- v-list-item-avatar

                    v-list-item-content.py-2
                        v-list-item-title(style="font-weight: 500;")
                            template(v-if="campaignTypeNames && campaignTypeNames.length > 0")
                                | {{ campaignTypeNames.join(", ") }}
                            template(v-else) All


                        v-list-item-subtitle Campaign Type(s)

            div(style='padding: 0px 20px;')
                v-divider.ma-0

        template(v-if="!hideDispositions")
            v-list.pb-0(subheader two-line)
                v-list-item
                    //- v-list-item-avatar

                    v-list-item-content.py-2
                        v-list-item-title(style="font-weight: 500;")
                            template(v-if="dispositionDescriptions && dispositionDescriptions.length > 0")
                                | {{ dispositionDescriptions.join(", ") }}
                            template(v-else) All


                        v-list-item-subtitle Disposition(s)

            div(style='padding: 0px 20px;')
                v-divider.ma-0

        v-list.pb-0(subheader two-line)
            v-list-item
                //- v-list-item-avatar

                v-list-item-content.py-2
                    v-list-item-title(style="font-weight: 500;")
                        template(v-if="userDisplayNames && userDisplayNames.length > 0")
                            | {{ userDisplayNames.join(", ") }}
                        template(v-else) All

                    template(v-if="validUser")
                        v-list-item-subtitle User(s)
                    template(v-else)
                        v-list-item-subtitle Employee(s)

        template(v-if="readonly")
            div(style='padding: 0px 20px;')
                v-divider.ma-0

            v-list.pb-0(subheader two-line)
                v-list-item
                    //- v-list-item-avatar

                    v-list-item-content.py-2
                        v-card-text.pa-0
                            template(v-if="notes && notes.length > 0")
                                | {{ notes }}
                            template(v-else) ---


                        v-list-item-subtitle Notes



</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // Data
    import { 
    } from "@/data";

    // Components
    import DestroyDialog from '@/components/scorecard_criterions/destroy_dialog.vue';
    import FormDialog from '@/components/scorecard_criterions/form_dialog.vue';
    import StatusText from '@/components/shared/status_text.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
            init() {
                return;
            },
        },
        computed: {
            validScorecard() {
                return this.scorecard?.scorecard_id > 0;
            },
            validScorecardCriterion() {
                return this.scorecardCriterion?.scorecard_criterion_id > 0;
            },
            validUser() {
                return  this.scorecard?.user_id > 0 || this.scorecard?.llm_assessment?.user_id > 0;
            },
        },
        components: {
            DestroyDialog,
            FormDialog,
            StatusText,
        },
        props: {
            handleCreateScorecardCriterion: Function,
            handleDestroyScorecardCriterion: Function,
            handleUpdateScorecardCriterion: Function,
            hideDispositions: Boolean,
            hideConferenceLink: Boolean,
            readonly: Boolean,
            scorecard: Object,
            scorecardCriterion: Object,
            scorecardTemplate: Object,
            showSnackbar: Function,

            title: String,
            campaignNames: Array,
            campaignTypeNames: Array,
            communicationType: String,
            dispositionDescriptions: Array,
            notes: String,
            organizationNames: Array,
            status: String,
            userDisplayNames: Array,
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
</style>
